import { render } from "./GroupHotels.vue?vue&type=template&id=41ec44d2"
import script from "./GroupHotels.vue?vue&type=script&lang=js"
export * from "./GroupHotels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__